/**
 * GoalMarker - Pulsing goal indicator on the stage.
 *
 * Direct port from bumblebee GoalMarker.
 *
 * @see GitHub Issue #852
 * @see GitHub Issue #909 - Enhanced prominence for TASK_3 pond navigation
 */

export default class GoalMarker {
    /**
     * @param {HTMLElement} stage - Stage element
     * @param {number} goalX - Goal X position
     * @param {number} goalY - Goal Y position
     * @param {number} [tolerance] - Radius of the goal area
     */
    constructor (stage, goalX, goalY, tolerance) {
        this._stage = stage;
        this._goalX = goalX;
        this._goalY = goalY;
        this._tolerance = tolerance || 30;
        this._element = null;
        this._prominent = false;
    }

    show () {
        if (this._element) {
            this._element.style.display = '';
            return;
        }

        /* Enforce minimum 60x60 so marker is large enough for young children */
        const size = Math.max(this._tolerance * 2, 60);

        this._element = document.createElement('div');
        this._element.className = 'activity-goal-marker';
        if (this._prominent) {
            this._element.classList.add('activity-goal-marker-prominent');
        }
        this._element.style.left = `${this._goalX}px`;
        this._element.style.top = `${this._goalY}px`;
        this._element.style.width = `${size}px`;
        this._element.style.height = `${size}px`;

        this._stage.appendChild(this._element);
    }

    /**
     * Reposition the marker when sprites move (e.g. between phases).
     * @param {number} x - New goal X position
     * @param {number} y - New goal Y position
     */
    updatePosition (x, y) {
        this._goalX = x;
        this._goalY = y;
        if (this._element) {
            this._element.style.left = `${x}px`;
            this._element.style.top = `${y}px`;
        }
    }

    /**
     * Toggle the prominent visual mode used during TASK_3.
     * Adds a brighter, larger-pulse CSS class so the goal is
     * unmissable for a 5-year-old navigating around the pond.
     * @param {boolean} on
     */
    setProminent (on) {
        this._prominent = Boolean(on);
        if (this._element) {
            this._element.classList.toggle('activity-goal-marker-prominent', this._prominent);
        }
    }

    hide () {
        if (this._element) {
            this._element.style.display = 'none';
        }
    }

    destroy () {
        if (this._element && this._element.parentNode) {
            this._element.parentNode.removeChild(this._element);
        }
        this._element = null;
    }
}
